export const toParsedRichText = (value)=>{
    if (value != null && typeof value === 'object' && 'type' in value && value.type === 'quill-delta' && 'value' in value) {
        return value;
    }
    return {
        type: 'quill-delta',
        value
    };
};
